import React from "react";
import { graphql } from "gatsby";
import ArticleWrapper from "../components/Article/Wrapper/index.js";
import ArticleTitle from "../components/Article/ArticleTitle/index.js";
import Breadcrumbs from "../components/Breadcrumbs/index.js";
import Patterns from "../container/Patterns.js";
import FastLinks from "../components/FastLinks/index.js";
import AccountList from "../components/AccountList/index.js";
import ServiceList from "../components/ServiceList/index.js";
import PlainCards from "../components/PlainCards/index.js";
import FeatureCards from "../components/FeatureCards/index.js";
import ScrollSlider from "../components/ScrollSlider/index.js";
import data from "../components/SmallHero/data.js";
import { buildURLForMenuItem } from "../utils/buildURL.js";
import { Helmet } from "react-helmet";
import { text } from "../container/language.js";
import { usePageContext } from "../utils/PageContext.js";

export const CategoryItems = ({
  items,
  articleListType,
  body,
  parentCategory,
  blockMode = false,
}) => {
  return (
    <>
      {articleListType === "SCROLLING_SLIDER" && (
        <ScrollSlider
          data={items}
          blockMode={blockMode}
          parentCategory={parentCategory}
        />
      )}
      {articleListType === "PLAIN_CARD" && (
        <section class="site-block">
          <div class="wrapper">
            <PlainCards
              data={items}
              blockMode={blockMode}
              parentCategory={parentCategory}
            />
          </div>
        </section>
      )}
      {articleListType === "CARD_WITH_IMAGE" && (
        <section class="site-block">
          <div class="wrapper">
            <FeatureCards
              data={items}
              blockMode={blockMode}
              parentCategory={parentCategory}
            />
          </div>
        </section>
      )}
      {articleListType === "TILTING_PLAIN_CARD" && (
        <section class="site-block">
          <div class="wrapper">
            <ServiceList
              data={items}
              blockMode={blockMode}
              parentCategory={parentCategory}
            />
          </div>
        </section>
      )}
      {articleListType === "TILTING_CARD_WITH_IMAGE" && (
        <section class="site-block">
          <div class="wrapper">
            <AccountList
              data={items}
              blockMode={blockMode}
              parentCategory={parentCategory}
            />
          </div>
        </section>
      )}
      {articleListType === "PLAIN_CARD_2" && (
        <section class="site-block">
          <div class="wrapper">
            <FastLinks
              data={items.map((item) => {
                const url = buildURLForMenuItem(item).substring(1);
                const pureItem = item.article || item.category || item;

                return {
                  icon: "",
                  slug: url,
                  title: pureItem.title,
                };
              })}
            />
          </div>
        </section>
      )}
    </>
  );
};

export default function Category({ data }) {
  const { lang } = usePageContext();

  const category = data.api.category;
  const title = category.title;
  const subtitle = category.subtitle;
  const categories = category.parentCategory;
  const head = category.head || [];
  const body = category.body || [];
  const articles = category.articles || [];
  const categoryChildren = category.categories || [];
  const parentCategory = category.parentCategory || {};
  const showHeader = category.showHeader;
  const { articleListType } = category;

  const items = [...categoryChildren, ...articles];
  return (
    <>
      <Helmet>
        <title>Shkolla e Magjistraturës - {text(title, lang)}</title>
      </Helmet>
      <section>
        <div className="wrapper">
          <Breadcrumbs data={category} />
          <Patterns data={head} />
        </div>
      </section>

      <div class="content-wrapper">
        {showHeader && <ArticleTitle data={{ title, subtitle }} />}
        <section class="wrapper bg-light">
          <div class="container pb-14 pb-md-16">
            <div class="row">
              <div class="col-lg-12 mx-auto">
                <div class="blog single mt-n17">
                  <div class="card">
                    {/* <figure class="card-img-top">
                      <img
                        src="http://themes.iki-bir.com/sandbox/src/img/photos/b1.jpg"
                        alt=""
                      />
                    </figure> */}
                    <div class="card-body">
                      <div class="classic-view">
                        <article class="post">
                          <div class="post-content mb-5">
                            <CategoryItems
                              items={items}
                              articleListType={articleListType}
                              body={[]}
                              parentCategory={data.api.category}
                            />
                            {body.length ? (
                              <ArticleWrapper
                                expanded={
                                  category.width === "WIDE" ||
                                  category.width === "FULL"
                                }
                              >
                                {category.width === "FULL" ? (
                                  <Patterns data={body} />
                                ) : (
                                  <div className="wrapper">
                                    <Patterns data={body} />
                                  </div>
                                )}
                              </ArticleWrapper>
                            ) : null}
                          </div>
                          {/* <div className="post-footer d-md-flex flex-md-row justify-content-md-between align-items-center mt-8">
                            <div>
                              <ul class="list-unstyled tag-list mb-0">
                                <li>
                                  <HashTag>Still Life</HashTag>
                                </li>
                                <li>
                                  <HashTag>Urban</HashTag>
                                </li>
                              </ul>
                            </div>
                          </div> */}
                        </article>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export const pageQuery = graphql`
  fragment Category on API_Categories {
    id
    slug
  }

  query ($id: ID!) {
    api {
      category(id: $id, publicationState: LIVE) {
        displayTitle
        id
        slug
        width
        showHeader
        articleListType

        title {
          id
          text_en
          text_sq
        }

        subtitle {
          id
          text_en
          text_sq
        }

        categories {
          id
          title {
            id
            text_sq
            text_en
          }
          subtitle {
            id
            text_sq
            text_en
          }
          excerpt {
            id
            text_sq
            text_en
          }
          cover {
            url
          }
          coverScrollingSlider {
            url
          }
          slug
          parentCategory {
            ...Category
            slug
            title {
              id
              text_en
              text_sq
            }
            parentCategory {
              ...Category
              slug
              title {
                id
                text_en
                text_sq
              }
              parentCategory {
                ...Category
                slug
                title {
                  id
                  text_en
                  text_sq
                }
                parentCategory {
                  ...Category
                  slug
                  title {
                    id
                    text_en
                    text_sq
                  }
                }
              }
            }
          }
        }

        articles(sort: "updated_at:desc") {
          updated_at
          id
          title {
            id
            text_sq
            text_en
          }
          slug
          excerpt {
            id
            text_sq
            text_en
          }
          subtitle {
            id
            text_sq
            text_en
          }
          cover {
            id
            formats
            url
          }
          coverScrollingSlider {
            url
          }
        }

        parentCategory {
          ...Category
          slug
          title {
            id
            text_en
            text_sq
          }
          parentCategory {
            ...Category
            slug
            title {
              id
              text_en
              text_sq
            }
            parentCategory {
              ...Category
              slug
              title {
                id
                text_en
                text_sq
              }
              parentCategory {
                ...Category
                slug
                title {
                  id
                  text_en
                  text_sq
                }
              }
            }
          }
        }

        head {
          ...ArticleHeadDynamicZoneFragment
        }

        body {
          ...ArticleBodyDynamicZoneFragment

          ... on API_ComponentArticlePatternBodyTabs {
            id
            tabs {
              id
              title {
                id
                text_sq
                text_en
              }
              body {
                id
                text_sq
                text_en
              }
            }
          }

          ... on API_ComponentArticlePatternBodyReferencedTabs {
            id
            tabs {
              id
              tab {
                id
                __typename
                tabTitle {
                  text_en
                  text_sq
                }
                body {
                  ...ArticleTabsBodyDynamicZoneFragment
                }
              }
            }
          }

          ... on API_ComponentArticlePatternBodyFaq {
            id
            questions {
              id
              help_item {
                id
                created_at
                updated_at
                displayTitle
                title {
                  id
                  text_sq
                  text_en
                }
                content {
                  id
                  text_sq
                  text_en
                }
              }
            }
          }

          ... on API_ComponentArticlePatternBodyArticleTable {
            id
            rows {
              id
              articles {
                id
                article {
                  id
                  title {
                    text_sq
                    text_en
                  }
                  slug
                  category {
                    ...ArticleCategoryFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
